// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect } from 'react';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import Modal from '../_common/Modal';

const OfflineAlert = () => {
    const {
        setOffline
    } = useGlobalState();

    useEffect(() => {
        console.log('Initially ' + (window.navigator.onLine ? 'on' : 'off') + 'line');
        setOffline(!window.navigator.onLine);
        window.addEventListener('online', () => {
            setOffline(false);
            console.log('Online');
        });
        window.addEventListener('offline', () => {
            setOffline(true);
            Modal.Show({
                title: 'Connection Error',
                body: 'The Internet connection appears to be offline.',
                type: 'error'
            });
        });
    }, [])
}

export default OfflineAlert;